export default "__VITE_ASSET__BJ$h0$KC__"